module.exports = __webpack_public_path__ + "img/soundwave_7.dd77da9b.jpg";